import AbstractFavoritesService from './abstract-favorites-service';
import MojitoCore from 'mojito/core';

const NamedStorageService = MojitoCore.Services.Storage.NamedService;
const STORAGE_KEY = 'favorites';
const favoritesStorage = new NamedStorageService(STORAGE_KEY);

const updateStorage = events => {
    const favorites = favoritesStorage.getItem();

    favoritesStorage.setItem({
        ...favorites,
        events,
    });
};

/**
 * Class offering the possibility to interact with the mojito Favorites API.
 *
 * @class FavoritesService
 * @memberof Mojito.Services.Favorites
 */
class FavoritesService extends AbstractFavoritesService {
    /**
     * Fetch favorite events.
     *
     * @param {Function} successCallback - Success callback.
     * @param {Function} errorCallback - Error callback.
     * @returns {Promise} Fetch favorite events promise.
     */
    fetchFavoriteEventIds(successCallback, errorCallback) {
        const data = favoritesStorage.getItem()?.events || [];
        return Promise.resolve(data).then(successCallback).catch(errorCallback);
    }

    /**
     * Add event id to favorites.
     *
     * @param {string} eventId - Event id to add.
     * @returns {Promise} Add event id promise.
     */
    addFavoriteEventId(eventId) {
        const eventsInStorage = favoritesStorage.getItem()?.events || [];
        const events = [...eventsInStorage, eventId];
        updateStorage(events);

        return Promise.resolve(events);
    }

    /**
     * Remove event id from favorites.
     *
     * @param {string} eventId - Event id to remove.
     * @returns {Promise} Remove event id promise.
     */
    removeFavoriteEventId(eventId) {
        const events = favoritesStorage.getItem()?.events.filter(id => id !== eventId);
        updateStorage(events);

        return Promise.resolve(events);
    }
}

export default new FavoritesService();
